<template>
  <section
    id="about"
    class="co-bg-striped"
  >
    <div class="co-container-lg px-4 py-20 text-left md:text-center">
      <h2 class="co-heading-2 mb-8 text-center">
        <slot name="title">
          タイトルが入ります
        </slot>
      </h2>
      <slot name="discription">
        説明が入ります
      </slot>
    </div>
  </section>
</template>
